import { toast } from "react-toastify";

const options = {
  position: "bottom-right",
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: false,
  closeButton: true,
  autoClose: 3000,
};

const errorText = (value) => {
  if (!value) return "";
  if (typeof value === "string") return value;
  if (Array.isArray(value)) return value.map(errorText).filter(Boolean).join(", ");
  if (typeof value === "object") {
    if (typeof value.message === "string") return value.message;
    if (typeof value.msg === "string") return value.msg;
    return [...new Set(Object.values(value).map(errorText).filter(Boolean))].join(", ");
  }
  return String(value);
};

const success = (message) => toast.success(String(message), options);

const error = (message) => {
  const readable = errorText(message?.err || message?.error || message?.errors || message?.message || message)
    || "Something went wrong";
  toast.error(readable, options);
};

const info = (message) => toast.info(String(message), options);

export const toaster = { success, error, info };
